import { $createLinkNode } from '@lexical/link';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import clsx from 'clsx';
import { $createTextNode, $getSelection, $insertNodes, $isRangeSelection } from 'lexical';
import { useState } from 'react';

import { AnchorLinkSelectorContainer } from '~components/generic/elements/AnchorLinkSelector/AnchorLinkSelectorContainer';
import Button from '~components/generic/elements/Button';
import Input from '~components/generic/elements/Input/Input';
import { getUrlFromTextLinkData } from '~services/text-editor-utils';
import cssStyles from './TextLinkWidget.css';

type Props = {
  closeToolbar: () => void;
};

export const TextLinkWidget = ({ closeToolbar }: Props) => {
  const [editor] = useLexicalComposerContext();
  const [currentVal, setCurrentVal] = useState<string>(null);
  const [url, setUrl] = useState(null);
  const [useExternal, setUseExternal] = useState<boolean>();

  const handleExternalChange = (val: string) => {
    setUrl(val);
  };

  const handleInternalChange = (id: string, type?: string) => {
    const value = getUrlFromTextLinkData({ id, type });

    setCurrentVal(value);

    setUrl(value);
  };

  const handleSave = () => {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        const selectedText = selection.getTextContent();
        const linkNode = $createLinkNode(url, { target: '_blank' });
        linkNode.append($createTextNode(selectedText));
        $insertNodes([linkNode, $createTextNode('')]);
      }
    });
    closeToolbar();
  };

  return (
    <div id="text-link-widget" className={clsx(cssStyles.widget, 'u-padding-vertical-md', 'u-padding-horizontal-md')}>
      {useExternal ? (
        <span>
          <Input
            label="Link target (external)"
            type="text"
            value={url}
            onChange={handleExternalChange}
            className="u-block u-full-width"
            placeholder="https://google.de"
          />

          <Button
            className="u-size-xs c-button c-button--lightest"
            onClick={() => setUseExternal(false)}
            label="Use internal link target"
          />
        </span>
      ) : (
        <span>
          <AnchorLinkSelectorContainer
            value={currentVal}
            label="Link target (internal)"
            onSelectedValueChange={handleInternalChange}
            theme="light"
          />
          <Button
            className="u-size-xs c-button c-button--lightest"
            onClick={() => setUseExternal(true)}
            label="Use external link target"
          />
        </span>
      )}

      <div className="o-grid o-grid--unpad u-margin-top-lg">
        <div className="o-grid__cell o-text--right">
          <Button label="Cancel" className="c-button c-button--lightest u-margin-right-md" onClick={closeToolbar} />
          <Button label="Save" className="c-button" onClick={handleSave} />
        </div>
      </div>
    </div>
  );
};
